import { render } from "./N2fList.vue?vue&type=template&id=d0893ac8"
import script from "./N2fList.vue?vue&type=script&lang=ts"
export * from "./N2fList.vue?vue&type=script&lang=ts"
script.render = render

export default script